<script setup>
const props = defineProps({
  noButtonCall: {
    type: Boolean,
    default: false
  },
  customLogo: Boolean,
  noLink: Boolean,
  noFull: Boolean
})


const route = useRoute();
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

const handleLogoClick = () => {
  if (route?.path === '/') {
    scrollToTop();
  }
}
</script>

<template>
  <div :class="{'w-full': !noFull}" class="bg-white">
    <div class="flex justify-between items-center min-h-14 lg:min-h-[70px]">
      <slot v-if="customLogo" name="custom-logo"></slot>
      <NuxtLink v-else-if="!customLogo && !noLink" :to="{name:'index'}" class="py-2" @click="handleLogoClick">
          <VectorVehisHorizontal class="w-32 lg:w-auto"/>
      </NuxtLink>
      <VectorVehisHorizontal v-else class="w-32 lg:w-auto"/>

      <ButtonSwitch class="hidden lg:flex" />

      <ButtonCall v-if="!noButtonCall"/>
      <div v-else>
        <slot />
      </div>
    </div>
    <div>
      <slot name="content" />
    </div>
  </div>
</template>
